import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import Component, { type MapProps } from "./component";

const STYLE = {
  display: "flex",
  flex: 1,
  justifyContent: "center",
  minWidth: 0
};
type Props = WithChildren;
const mapStateToProps = (state: AppState, props: Props): MapProps => ({
  style: STYLE,
  ...props
});

export default connectCustom(mapStateToProps)(Component);
